/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PasswordValidationRuleName = {
    Length: 'length',
    PasswordVariants: 'password_variants',
    AdminVariants: 'admin_variants',
    UserVariants: 'user_variants',
    AlphanumericSequences1: 'alphanumeric_sequences_1',
    AlphanumericSequences2: 'alphanumeric_sequences_2',
    NumericSequencesAscending: 'numeric_sequences_ascending',
    NumericSequencesDescending: 'numeric_sequences_descending',
    NumericSubsequencesAscending: 'numeric_subsequences_ascending',
    NumericSubsequencesDescending: 'numeric_subsequences_descending',
    CommonPasswordXkcd: 'common_password_xkcd'
} as const;
export type PasswordValidationRuleName = typeof PasswordValidationRuleName[keyof typeof PasswordValidationRuleName];


export function instanceOfPasswordValidationRuleName(value: any): boolean {
    for (const key in PasswordValidationRuleName) {
        if (Object.prototype.hasOwnProperty.call(PasswordValidationRuleName, key)) {
            if (PasswordValidationRuleName[key as keyof typeof PasswordValidationRuleName] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PasswordValidationRuleNameFromJSON(json: any): PasswordValidationRuleName {
    return PasswordValidationRuleNameFromJSONTyped(json, false);
}

export function PasswordValidationRuleNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordValidationRuleName {
    return json as PasswordValidationRuleName;
}

export function PasswordValidationRuleNameToJSON(value?: PasswordValidationRuleName | null): any {
    return value as any;
}

export function PasswordValidationRuleNameToJSONTyped(value: any, ignoreDiscriminator: boolean): PasswordValidationRuleName {
    return value as PasswordValidationRuleName;
}

